module.exports = __webpack_public_path__ + "img/gem.20c3726f.png";